module.exports = __webpack_public_path__ + "static/Kit-Branded-76548b71683f2e6c6b15cffcce876687.png";